import { getCore } from '../../../client/core/getCore';
import { getDefaultClient } from '../../../client/defaultClient';
import { assertDefined } from '../../../utils/assertDefined';
import { createApiClient } from '../../apiClient';
import { logout } from '../../auth/logout';

type RevokeRegisteredDeviceParams = {
  deviceRegistrationId: string;
};

export const revokeRegisteredDevice = async (
  { deviceRegistrationId }: RevokeRegisteredDeviceParams,
  client = getDefaultClient()
): Promise<void> => {
  assertDefined(deviceRegistrationId, 'deviceRegistrationId is required');

  const core = getCore(client);
  const apiClient = createApiClient({}, client);

  const response = await apiClient.deleteDeviceRegistration({
    deviceRegistrationId,
    environmentId: core.environmentId,
  });

  if (response.currentDeviceRevoked) {
    await logout(client);
  }
};
